import { IDeviceStrategy, DeviceInfo, SessionOptions } from './IDeviceStrategy';

export class HighPerformanceDeviceStrategy implements IDeviceStrategy {
  getDeviceInfo(): DeviceInfo {
    const nav = navigator as any;
    const memory = nav.deviceMemory || nav.hardwareConcurrency || 4;
    const connection = nav.connection || nav.mozConnection || nav.webkitConnection;
    const isSlowConnection = connection && (connection.effectiveType === 'slow-2g' || connection.effectiveType === '2g');
    
    return {
      estimatedRAM: memory,
      isLowMemory: false,
      isSlowConnection: isSlowConnection
    };
  }

  getSessionOptions(debug: boolean): SessionOptions {
    return {
      executionProviders: ['webgl', 'wasm'],
      graphOptimizationLevel: 'all',
      logSeverityLevel: debug ? 2 : 4,
      logVerbosityLevel: 0,
      enableCpuMemArena: true,
      enableMemPattern: true,
      executionMode: 'parallel',
      interOpNumThreads: 2,
      intraOpNumThreads: 2,
    };
  }

  shouldUseSequentialLoading(): boolean {
    return false;
  }
}